module.exports = __webpack_public_path__ + "static/media/heart.0e34b712.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heart.svg
// module id = 311
// module chunks = 0